const AppUsers = {
  appUsers: 'Users',
  addAppUsers: 'Add Users',
  editAppUsers: 'Edit Users',
  contactUs: 'Contact Us',
};
export default AppUsers;
